module.exports = __webpack_public_path__ + "static/media/zheng2-3@2x.13bbf646.png";